import React from 'react';
import { Avatar } from '@mui/material';
import { getPartnerLogoAvatarSx, PARTNER_LOGO_SIZE } from '../partnerDashboardTheme';

/**
 * Shared partner logo/avatar — shape and display values come from the parent.
 * @param {'square' | 'circle'} shape — square on dashboard hero, circle on company info
 */
const PartnerLogoAvatar = ({
  src,
  alt = 'Company logo',
  initial = 'P',
  shape = 'circle',
  size = PARTNER_LOGO_SIZE,
  sx,
}) => (
  <Avatar
    variant={shape === 'square' ? 'square' : 'circular'}
    src={src || undefined}
    alt={alt}
    sx={{
      ...getPartnerLogoAvatarSx(shape),
      width: size,
      height: size,
      ...sx,
    }}
  >
    {!src ? initial : null}
  </Avatar>
);

export default PartnerLogoAvatar;
